import React from 'react';
import TransferSdk from "@smash-sdk/transfer/ejs/07-2022";
import { TableHeaders } from '../../../components/SmashTable/SmashTableHead';
import SmashTable from '../../../components/SmashTable/SmashTable';
import { useTransferFiles } from '../hooks/useTransferFiles';

const ListTransferFiles = () => {

  const [isLoading, files, previous, next] = useTransferFiles();

  const headers: TableHeaders[] = [{
      label: 'File name',
      accessor: 'name',
      sortable: true,
  }, {
      label: 'Transfer size',
      accessor: 'size',
      type: 'bytes',
      sortable: false,
  }];

  return (
    <SmashTable 
            loading={isLoading} 
            headers={headers}
            items={files} 
            textFallback={'No files'} 
          />
  )
}

export default ListTransferFiles